<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Employee CTC Details Report</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFY"
             
            >
              <option [ngValue]="null">Select Year</option>
              <option *ngFor="let finance of financialYearList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Branch<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedBranch"
            >
              <option [ngValue]="null">Select Branch</option>
              <option *ngFor="let branch of branchList" [ngValue]="branch">
                {{ branch.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row mt-2">
      <!-- <div class="col-sm-3"></div> -->
      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onViewReport()"
        >
          View Report
        </button>
      </div>
      <!-- <div class="col-sm-2" *ngIf="showExportToExcelButton">
        <button
          (click)="exportToExcelClick()"
          class="btn btn-sm btn-block btn-outline-theme"
        >
          <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
        </button>
      </div> -->
    </div>
  </div>
</div>
<div class="container" id="mainContent" *ngIf="modalFormObjList != null">
  <div class="row pt-3 justify-content-center text-center">
    <span class="bg-theme-title"
      >P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>
  
  <div class="table-responsive cnstr-record">
    <table class="table table-bordered heading-hvr">
      <thead>
      <tr>
        <th>Id</th>
        <th>Name</th>
        <th>Designation</th>
        <th>Service Vertical</th>
        <th>Branch</th>
        <th>Reporting Partner</th>
        <th>Joining Date</th>
        <th>CTC From Date</th>
        <th>CTC To Date</th>
        <th>CTC</th>
      </tr>
      </thead>
      <tbody *ngFor="let ctcDetails of modalFormObjList; index as i">
        <tr>
          <td>{{i+1}}</td>
          <td>{{ ctcDetails.name }}</td>
          <td>{{  ctcDetails.designation }}</td>
          <td>{{ ctcDetails.serviceVertical }}</td>
          <td>{{ ctcDetails.branch }}</td>
          <td>{{ ctcDetails.reportingPartner }}</td>
          <td>{{ ctcDetails.joiningDate | date: "dd-MM-yyyy" }}</td>
          <td>{{ ctcDetails.ctcFromDate | date: "dd-MM-yyyy" }}</td>
          <td>{{ ctcDetails.ctcToDate | date: "dd-MM-yyyy" }}</td>
          <td>{{ ctcDetails.ctc }}</td>
        </tr>
       </tbody>
      </table>
          
  </div>
</div>
</div>
